import React from "react";

export const PageHeader = ({ title, subtitle, testIdPrefix }) => {
  return (
    <div className="mb-8">
      <h1
        className="text-3xl sm:text-4xl font-semibold tracking-tight text-slate-50"
        data-testid={`${testIdPrefix}-title`}
      >
        {title}
      </h1>
      {subtitle ? (
        <p
          className="mt-2 text-sm sm:text-base text-slate-300 max-w-2xl"
          data-testid={`${testIdPrefix}-subtitle`}
        >
          {subtitle}
        </p>
      ) : null}
    </div>
  );
};

export default PageHeader;
